const AI_PDF_CONST = {
  API_ENDPOINT: {
    LOGIN: "/users/login",
    DOCS: "/docs/",
    GPT_QUERY: "/gpt/query",
    GPT_HISTORY: "/gpt/qa_history",
    GET_SIGNED_URL: "/docs/get_signed_url",
  },

  ROUTE: {
    ROOT: "/",
    HOME: "/home",
    DASHBOARD: "/dashboard",
    DOCUMENTS: "/documents",
    HOLIOS: "/holios",
    HOLIOS_UPLOAD_DATA: "/holios_upload_data",
    AI_AUTOMATION: "/ai-automation",
    ADMIN_ORGS: "/admin/orgs",
    ADMIN_ORG_USERS: "/admin/orgs/:org_id/users",
  },
};

export default AI_PDF_CONST;
